export const DEFAULT_STATE = {
    data: null,
    dataByPublisher: null,
    isLoading: false,
    formError: null,
};
